<template>
  <div class="header" id="boxFixed" :class="{ is_fixed: isFixed }">
    <div class="block">
      <!-- 搜索框部分 -->
      <div class="flex ">
        <!-- logo部分 -->
        <div class="logo">
          <router-link tag="div" :to="{ path: '/' }">
            <img src="/static/logos.png" class="left" :alt="$t('骏芯商城')" />
            <img src="/static/logozi.png" class="right" alt="" />
          </router-link>
        </div>
        <div class="search_">
          <!-- 搜索框 -->
          <div class="search">
            <div class="inputs" :class="{ is_fixed_inputs: isFixed }">
              <el-input
                :placeholder="$t('请输入内容')"
                @change="goSeh(keyInput, select)"
                v-model="keyInput"
                class="input-with-select"
              >
                <el-select
                  v-model="select"
                  slot="prepend"
                  :placeholder="$t('全部商品')"
                >
                  <el-option :label="$t('全部商品')" value="-1"></el-option>
                  <el-option :label="$t('骏芯自营')" value="0"></el-option>
                  <el-option :label="$t('爆款推荐')" value="2"></el-option>
                  <el-option :label="$t('成品方案')" value="4"></el-option>
                  <!-- <el-option label="国产替代方案"
                             value="5"></el-option> -->
                </el-select>
                <el-button
                  slot="append"
                  @click="goSeh(keyInput, select)"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
              <div class="hot" v-if="!isFixed">
                <!--  v-show="index<6" -->
                <div
                  class="item cur"
                  @click="keyInput = item.keywords"
                  v-for="(item, index) in keywordsList"
                  :key="index"
                >
                  {{ item.keywords }}
                </div>
              </div>
            </div>
            <div>
              <el-select
                v-model="lang"
                @change="handleChangeLang"
                class="language-select"
              >
                <el-option value="zh" :label="$t('简体中文')"></el-option>
                <el-option value="en" :label="$t('英语')"></el-option>
                <el-option value="ru" :label="$t('俄语')"></el-option>
              </el-select>
            </div>
            <!-- <div class="cart"
                 @click="goPage()">
              <div>
                <i class="iconfont icon-gouwugouwuchedinggou"></i>
                <span>{{cartnum}}</span>
              </div>
              <span>我的购物车</span>

            </div> -->

          
          </div>
          <!-- 登录 -->
          <div class="login" v-if="!isFixed">
            <div class="title">{{ $t("Hi,上午好") }}</div>
            <div class="msg">{{ $t("欢迎来到骏芯商城") }}</div>
            <div class="btn" v-if="isLogin">
              {{ userinfo.nickname }}
            </div>
            <div class="btn" v-if="!isLogin">
              <router-link
                tag="span"
                :to="{ path: '/login/signIn' }"
                class="pointer"
                >{{ $t("登录") }}</router-link
              >
              <router-link
                tag="span"
                :to="{ path: '/login/login' }"
                class="pointer"
                >{{ $t("注册") }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <!-- tab -->
      <div class="flex" v-if="!isFixed" style="padding-top:20px">
        <router-link tag="div" v-if="!isFixed" :to="{ path: '/' }" class="cl">{{
          $t("全部商品分类")
        }}</router-link>
        <div class="tab" v-if="!isFixed">
          <div class="list">
            <div
              class="item pointer"
              :class="actCode == 0 ? 'actCalse' : ''"
              @click="goSeh('/', 0)"
            >
              {{ $t("现货库存") }}
            </div>
            <div
              class="item pointer"
              :class="actCode == 2 ? 'actCalse' : ''"
              @click="goSeh('/', 2)"
            >
              {{ $t("爆款推荐") }}
              <div class="t">{{ $t("热") }}</div>
            </div>
            <div
              class="item pointer"
              :class="actCode == 1 ? 'actCalse' : ''"
              @click="goSeh('/', 1)"
            >
              {{ $t("骏芯秒杀") }}
              <div class="t">{{ $t("爆") }}</div>
            </div>
            <!--            <div class="item pointer"-->
            <!--                 :class="actCode==3?'actCalse':''"-->
            <!--                 @click="goSeh('/',3)">-->
            <!--              领券中心-->
            <!--            </div>-->
            <div
              class="item pointer"
              :class="actCode == 8 ? 'actCalse' : ''"
              @click="goSeh('/', 8)"
            >
              {{ $t("镜头模组") }}
            </div>
            <div
              class="item pointer"
              :class="actCode == 4 || actCode == 5 ? 'actCalse' : ''"
              @click="goSeh('/', 4)"
            >
              {{ $t("成品方案") }}
            </div>
            <div
              class="item pointer"
              :class="actCode == 6 ? 'actCalse' : ''"
              @click="goSeh('/', 6)"
            >
              {{ $t("兑换专区") }}
            </div>
            <div class="item pointer" @click="goPageJs">
              {{ $t("技术论坛") }}
              <div class="t">{{ $t("HDI板") }}</div>
            </div>

            <!-- <div class="item pointer"
                 :class="actCode==6?'actCalse':''"
                 @click="goSeh('/',6)">骏芯视频</div> -->
            <div
              class="item pointer"
              :class="actCode == 7 ? 'actCalse' : ''"
              @click="goSeh('/', 7)"
            >
              {{ $t("入驻骏芯") }}
              <div class="t">{{ $t("加入") }}</div>
            </div>
          </div>
        </div>
        <div class="rightmk">
          <div>{{ $t("专业元器件交易商城") }}</div>
          <div class="b">{{ $t("原装正品·服务优质·供应稳定") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  inject: ["reload"],
  props: {
    title: {
      type: String | Number
    },
    selectCode: {
      type: String | Number
    }
  },
  data() {
    return {
      actCode: "-1",
      keyInput: "",
      select: "-1",
      isLogin: false,
      keywordsList: [],
      cartnum: 0,
      userinfo: {},
      isFixed: false,
      offsetTop: 0,
      lang: "zh"
    };
  },
  created() {
    let that = this;
    setTimeout(() => {
      that.userinfo = JSON.parse(localStorage.getItem("userinfo"));
    }, 1500);
    this.actCode = this.selectCode;
    if (this.selectCode && this.title) {
      this.select = this.selectCode;
    }
    if (this.title) {
      this.keyInput = this.title;
    }
  },
  mounted() {
    this.getSelf();
    window.addEventListener("scroll", this.initHeight);
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
      this.offsetTop = document.querySelector("#boxFixed").offsetTop;
    });

    this.lang = localStorage.getItem("language") || "zh";
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      // console.log('scrollTop', scrollTop)
      if (scrollTop > 200) {
        // this.isFixed = scrollTop > this.offsetTop;
        this.isFixed = true;
      } else {
        // this.isFixed = false
        this.isFixed = scrollTop > this.offsetTop;
      }
      this.$emit("change", this.isFixed);
    },
    goSeh(keyInput, select) {
      if (!keyInput) {
        return this.$jx.open1(this.$t("请输入需要搜索的内容"));
      }
      // 全部
      if (select == -1) {
        this.$router.push({
          name: "allProducts",
          params: { name: select, title: keyInput, pid: "-1", topid: "-1" }
        });
      }
      //  自营
      if (select == 0) {
        console.log(keyInput);
        this.$router.push({
          name: "proprietary",
          params: { name: select, title: keyInput, pid: "-1", topid: "-1" }
        });
      }
      //  秒杀 seckill
      if (select == 1) {
        this.$router.push({ name: "seckill" });
      }
      //  爆款
      if (select == 2) {
        this.$router.push({
          name: "hotCake",
          params: { name: select, title: keyInput, pid: "-1", topid: "-1" }
        });
      }
      //  领券中心
      // if (select == 3) {
      //   this.$router.push({ name: 'volumeIndex' })
      // }
      //  镜头模组
      if (select == 8) {
        this.$router.push({ name: "lensMod" });
      }
      // 成品
      if (select == 4) {
        this.$router.push({
          name: "endProduct",
          params: { name: select, title: keyInput }
        });
      }
      //  国产
      if (select == 5) {
        this.$router.push({
          name: "endProduct",
          params: { name: select, title: keyInput }
        });
      }
      //  兑换专区
      if (select == 6) {
        this.$router.push({ name: "jifeng" });
      }
      //  入驻骏芯
      if (select == 7) {
        this.$router.push({ name: "agent" });
      }
      this.reload();
    },
    goPageJs() {
      let common = JSON.parse(localStorage.getItem("jx:common")).data;
      if (localStorage.token) {
        window.open(common.web_forum + "?token=" + localStorage.token);
      } else {
        window.open(common.web_forum);
      }
    },
    goPage() {
      this.$jx.IsToken().then(res => {
        if (res) {
          this.$router.push({ path: "/shop/shopCar" });
        } else {
          this.$router.push({ path: "/login/signIn" });
        }
      });
    },
    getSelf() {
      setTimeout(() => {
        this.contact = JSON.parse(localStorage.getItem("jx:common")).data;
      }, 1000);
      // 获取热门搜索
      this.$http.get("/wanlshop/common/init", {}).then(
        res => {
          this.keywordsList = res.data.modulesData.searchModules;
        },
        err => {}
      );

      if (localStorage.getItem("token")) {
        this.$http.get("/wanlshop/cart/getcartnum", {}).then(
          res => {
            this.cartnum = res.data;
          },
          err => {}
        );
        this.isLogin = true;
      }
    },
    // 切换语言
    handleChangeLang(lang) {
      localStorage.setItem("language", lang);
      this.$i18n.locale = lang;
      location.reload()
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  padding-top: 30px;
  background-color: #fff;

  .block {
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;

    .flex {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .logo {
        flex: 1;
        /deep/ .router-link-active {
          display: flex;
          align-items: center;
          .left {
            width: 60px;
          }
          .right {
            padding-left: 20px;
            width: 130px;
          }
        }
      }
      .search_ {
        flex: 4;
        display: flex;
        align-items: flex-start;
        margin-left: 30px;
        .login {
          flex: 1;
          text-align: center;
          .title {
            font-weight: bold;
            font-size: 18px;
          }
          .msg {
            font-size: 12px;
          }
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            .touxiang {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              .img {
                width: 40px;
                height: 40px;
              }
            }
            span {
              color: #363634;
              font-size: 12px;
              font-weight: 600;
              margin: 0 4px;
              position: relative;

              &:first-child::after {
                display: inline-block;
                content: "";
                width: 1px;
                height: 12px;
                background-color: #363634;
                position: absolute;
                right: -5px;
                top: 2px;
              }
            }
          }
        }
        .search {
          flex: 4;
          display: flex;
          align-items: flex-start;
          .inputs {
            flex: 1;
          }
          /deep/.el-input-group {
            width: 100%;
          }

          .hot {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding-top: 10px;
            cursor: pointer;

            .item {
              color: #999999;
              font-size: 12px;
              margin: 0 4px;

              &.cur {
                color: #0094e7;
              }
            }
          }

          .cart {
            margin-left: 30px;
            width: 100px;
            height: 38px;
            line-height: 30px;
            color: #0094e7;
            font-size: 12px;
            border: 1px solid #dddddd;
            padding: 0 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            span {
              color: #333333;
            }
            > div {
              position: relative;
              margin-right: 15px;

              span {
                position: absolute;
                background-color: #ff971d;
                color: #fff;
                font-size: 10px;
                transform: scale(0.8);
                display: inline-block;
                height: 16px;
                top: 2px;
                right: -14px;
                line-height: 16px;
                padding: 0 4px;
                border-radius: 10px;
                text-align: center;
              }
            }
          }
        }
      }

      .cl {
        flex: 1;
        color: #fff;
        background-color: #0094e7;
        border-radius: 6px;
        line-height: 36px;
        width: 190px;
        padding: 0 15px;
        font-size: 14px;
        box-sizing: border-box;
        // margin-top: 10px;
        font-weight: 600;
        text-align: center;
      }
      .tab {
        flex: 5;
        width: 100%;
        // margin: 36px 0 0px 0;
        padding: 0 30px;
        box-sizing: border-box;

        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .item {
            white-space: nowrap;
            margin: 0 10px;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            position: relative;

            &:first-child {
              margin-left: 0;
            }

            &:last-child {
              margin-right: 0;
            }

            .t {
              position: absolute;
              background-color: #0094e7;
              color: #fff;
              top: -24px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 12px;
              display: inline-block;
              border-radius: 4px;
              height: 20px;
              line-height: 20px;
              padding: 0 4px;

              &::after {
                content: "";
                width: 0;
                height: 0;
                border: 5px solid;
                border-color: #0094e7 transparent transparent transparent;
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }

          .actCalse {
            color: #0094e7;
          }
        }
      }
      .rightmk {
        // flex: 1;
        text-align: center;
        width: 190px;
        // margin-left: 20px;
        div {
          font-size: 16px;
        }
        div.b {
          font-size: 12px;
          color: #01cdef;
        }
      }
    }
    > .logo {
      display: flex;
      flex-direction: column;
      align-items: center;

      img.left {
        width: 40px;
      }
      img.right {
        width: 80px;
      }

      .cl {
        color: #fff;
        background-color: #0094e7;
        border-radius: 6px;
        line-height: 36px;
        width: 190px;
        padding: 0 15px;
        font-size: 14px;
        box-sizing: border-box;
        margin-top: 10px;
        font-weight: 600;
        text-align: center;
      }
    }

    > .center {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      flex: 1;
      overflow: hidden;

      .top {
        width: 100%;
        box-sizing: border-box;
        padding: 0 30px;

        .search {
          display: flex;
          justify-content: flex-end;

          .blocks {
            display: flex;
            flex-direction: column;

            .inputs {
              width: 600px;
              margin-right: 20px;
              margin-bottom: 10px;
            }
          }

          .cart {
            height: 38px;
            line-height: 38px;
            color: #0094e7;
            font-size: 12px;
            border: 1px solid #dddddd;
            padding: 0 15px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            > div {
              position: relative;
              margin-right: 15px;

              span {
                position: absolute;
                background-color: #ff971d;
                color: #fff;
                font-size: 10px;
                transform: scale(0.8);
                display: inline-block;
                height: 16px;
                top: 2px;
                right: -14px;
                line-height: 16px;
                padding: 0 4px;
                border-radius: 10px;
                text-align: center;
              }
            }
          }
        }
      }

      .tab {
        width: 100%;
        margin: 36px 0 0px 0;
        padding: 0 30px;
        box-sizing: border-box;

        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          .item {
            white-space: nowrap;
            margin: 0 10px;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            position: relative;

            &:first-child {
              margin-left: 0;
            }

            &:last-child {
              margin-right: 0;
            }

            .t {
              position: absolute;
              background-color: #0094e7;
              color: #fff;
              top: -24px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 12px;
              display: inline-block;
              border-radius: 4px;
              height: 20px;
              line-height: 20px;
              padding: 0 4px;

              &::after {
                content: "";
                width: 0;
                height: 0;
                border: 5px solid;
                border-color: #0094e7 transparent transparent transparent;
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
          }

          .actCalse {
            color: #0094e7;
          }
        }
      }
    }
    .btnzw {
      min-width: 200px;
    }
    > .login {
      font-size: 14px;
      border: 1px solid #dddddd;
      padding: 20px 20px 40px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 14px;
      margin-bottom: 10px;

      .title {
        color: #0094e7;
        font-size: 14px;
      }

      .btn {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .touxiang {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .img {
            width: 40px;
            height: 40px;
          }
        }
        span {
          color: #363634;
          font-size: 12px;
          margin: 0 4px;
          position: relative;

          &:first-child::after {
            display: inline-block;
            content: "";
            width: 1px;
            height: 12px;
            background-color: #363634;
            position: absolute;
            right: -5px;
            top: 2px;
          }
        }
      }
    }
  }
}

.is_fixed_inputs {
  margin-bottom: 0 !important;
}
.is_fixed_img {
  width: 190px;
  img {
    width: 40px !important;
  }
}
.noneDiv {
  display: none;
}
.is_fixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  padding: 10px 0 !important;
}
/deep/ .el-input-group__prepend {
  background-color: inherit;
  border-color: #0094e7;
  color: #0094e7;
  padding: 0 14px;
  border-width: 2px;
  .el-input__suffix .el-select__caret {
    color: #0094e7;
  }
}
/deep/ .el-input-group__append {
  background-color: #0094e7;
  border-color: #0094e7;
  .el-icon-search {
    color: #ffffff;
  }
}
/deep/ .el-input__inner {
  border-color: #0094e7;
  border-width: 2px;
}
/deep/ .el-select {
  .el-input {
    width: 140px;
  }
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.language-select {
  margin-left: 30px;
  /deep/ .el-input {
    width: 120px;
  }
  /deep/ .el-input__inner {
    color: #0094e7;
    border-color: #0094e7;
    border-radius: 0;
  }
  /deep/ .el-select__caret {
    color: #0094e7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue